import { render, staticRenderFns } from "./AlertDetailPanel.vue?vue&type=template&id=4fb5dfe4&scoped=true"
import script from "./AlertDetailPanel.vue?vue&type=script&lang=js"
export * from "./AlertDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./AlertDetailPanel.vue?vue&type=style&index=0&id=4fb5dfe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb5dfe4",
  null
  
)

export default component.exports